import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
    selector: 'wdx-avatar-container',
    templateUrl: './wdx-avatar-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxAvatarContainerComponent {
    @Input() popupEnabled = true;
}
